<template>
  <div>
    <a :href="urlKatalogLink" v-if="katalogEnabled && isMobileNavigationOpen" class="mobile-katalog">
      <img :src="urlKatalogImg" alt="Katalog" title="Katalog">
    </a>
    <template v-if="blog.length > 0">
      <div class="mobile-navigation" :class="[ {'open': isMobileNavigationOpen }   ,{ 'blogMobileNav': blog.length > 0} ]">
        <div v-show="isNavigationInitialized">
          <ul class="mainmenu w-100 p-0 m-0 menu-active">
            <li class="ddown" v-for="blogitem in blog">
              <a :aria-label="blogitem.name" :href="blogitem.nameUrl">{{ blogitem.name }}</a>
            </li>
            <li class="ddown">
              <a href="/" aria-label="bigtex Shop" style="color:rgb(193, 34, 50)!important;font-size:18px;font-weight:600">
                {{ $translate("Bigtex5::Template.backToShop") }}
              </a>
            </li>
            <li>
             <span class="nav-direction d-flex align-items-center mHeader">
                  <div class="flex-fill text-center">
                      {{ $translate("Bigtex5::Template.headerMisc") }}
                  </div>
              </span>
            </li>
            <li class="ddown">
              <a :href="urlContact" aria-label="Kontakt">
                <i class="fa fa-envelope"></i>
                {{ $translate("Bigtex5::Template.headerContactForm") }}
              </a>
            </li>
            <li class="ddown">
              <a :href="urlNewsletter" aria-label="newsletter">
                <i class="fa fa-envelope-o"></i>
                {{ $translate("Bigtex5::Template.headerNewsletter") }}
              </a>
            </li>
            <li class="ddown">
              <a :href="urlKatalog" aria-label="Katalog">
                <i class="fa fa-bookmark"></i>
                {{ $translate("Bigtex5::Template.headerKatalog") }}
              </a>
            </li>
            <li class="ddown" v-if="calcTelTime" aria-label="Telefon">
              <a :href="urlPhone">
                <i class="fa fa-phone"></i> {{ $translate("Bigtex5::Template.headerPhoneAssist") }}
              </a>
            </li>
          </ul>
        </div>
        <template v-if="!isNavigationInitialized">
          <ul class="mainmenu w-100 p-0 m-0 menu-active">
            <li class="ddown" v-for="index in skeletonItemCount" :key="'skeleton-' + index">
              <span class="nav-placeholder m-3" :style="{width: getRandomWidth() + '%'}"></span>
            </li>
          </ul>
        </template>
      </div>
    </template>
    <template v-else>
      <div class="mobile-navigation" :class="[ {'open': isMobileNavigationOpen }]">
        <div v-show="isNavigationInitialized">
          <ul v-menu id="menu-1" class="mainmenu w-100 p-0 m-0 menu-active">
            <li class="ddown" v-if="dataContainer1.parent" @click="slideTo(dataContainer1.parent && dataContainer1.parent.parent || null, true)">
                       <span class="nav-direction d-flex align-items-center mHeader">
                          <template v-if="selectedCat">
                              <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
                              <div class="flex-fill text-center" >
                                  {{selectedCat.details[0].name }}
                              </div>
                          </template>
                      </span>
            </li>
            <li class="ddown" v-for="category in dataContainer1.categories">
              <a :href="getCategoryUrl(category.url)" :aria-label="'Link zu '+ category.details[0].name">{{ category.details[0].name }}</a>
              <span class="nav-direction" v-if="category.childCount" @click="slideTo(category)">
                           <i class="fa fa-arrow-right" aria-hidden="true"></i>
                      </span>
            </li>
            <template v-if="dataContainer1.categories[0]">
              <li class="ddown" v-for="number in dataContainer1.categories[0].siblingCount - dataContainer1.categories.length">
                <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
              </li>
            </template>
            <template v-else-if="dataContainer1.parent">
              <li class="ddown" v-for="number in dataContainer1.parent.childCount">
                <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
              </li>
            </template>
            <li class="ddown">
              <a href="/magazin/" aria-label="Blog">
                Magazin
              </a>
            </li>
            <li class="ddown">
              <a target="_blank" href="https://www.google.com/storepages?q=bigtex.de&c=DE&v=19&hl=de&so=NEWEST#reviews" aria-label="Rezensionen bei Google">
                <i class="fa fa-google mr-2 google-bg"></i> {{ getRating() }} / 5,0 Google Rezensionen
              </a>
            </li>
            <template v-if="breadcrumbs.length == 0">
              <li>
               <span class="nav-direction d-flex align-items-center mHeader">
                    <div class="flex-fill text-center">
                        {{ $translate("Bigtex5::Template.headerMisc") }}
                    </div>
                </span>
              </li>
              <li class="ddown">
                <a :href="urlContact" aria-label="Kontakt">
                  <i class="fa fa-envelope"></i>
                  {{ $translate("Bigtex5::Template.headerContactForm") }}
                </a>
              </li>
              <li class="ddown">
                <a :href="urlNewsletter" aria-label="Newsletter">
                  <i class="fa fa-envelope-o"></i>
                  {{ $translate("Bigtex5::Template.headerNewsletter") }}
                </a>
              </li>
              <li class="ddown">
                <a :href="urlKatalog" aria-label="Katalog">
                  <i class="fa fa-bookmark"></i>
                  {{ $translate("Bigtex5::Template.headerKatalog") }}
                </a>
              </li>
              <li class="ddown" v-if="calcTelTime">
                <a :href="urlPhone" aria-label="Telefon">
                  <i class="fa fa-phone"></i> {{ $translate("Bigtex5::Template.headerPhoneAssist") }}
                </a>
              </li>
            </template>
          </ul>
          <ul v-menu id="menu-2" class="mainmenu w-100 p-0 m-0">
            <li class="ddown" v-if="dataContainer2.parent" @click="slideTo(dataContainer2.parent && dataContainer2.parent.parent || null, true)">
                      <span class="nav-direction d-flex align-items-center mHeader">
                          <template v-if="selectedCat">
                              <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
                              <div class="flex-fill text-center">
                                  {{selectedCat.details[0].name }}
                              </div>
                          </template>
                      </span>
            </li>

            <li  class="ddown" v-for="category in dataContainer2.categories">
              <a :aria-label="'Link zu '+ category.details[0].name" :href="getCategoryUrl(category.url)">{{ category.details[0].name }}</a>
              <span class="nav-direction" v-if="category.childCount" @click="slideTo(category)">
                           <i class="fa fa-arrow-right" aria-hidden="true"></i>
                      </span>
            </li>
            <template v-if="dataContainer2.categories[0]">
              <li class="ddown" v-for="number in dataContainer2.categories[0].siblingCount - dataContainer2.categories.length">
                <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
              </li>
            </template>
            <template v-else-if="dataContainer2.parent">
              <li class="ddown" v-for="number in dataContainer2.parent.childCount">
                <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
              </li>
            </template>
            <template v-if="breadcrumbs.length == 0">
              <li>
                 <span class="nav-direction d-flex align-items-center mHeader">
                      <div class="flex-fill text-center">
                          {{ $translate("Bigtex5::Template.headerMisc") }}
                      </div>
                  </span>
              </li>
              <li class="ddown">
                <a aria-label="Kontakt" :href="urlContact">
                  {{ $translate("Bigtex5::Template.headerContactForm") }}
                </a>
              </li>
              <li class="ddown">
                <a :href="urlNewsletter" aria-label="Newsletter">
                  {{ $translate("Bigtex5::Template.headerNewsletter") }}
                </a>
              </li>
              <li class="ddown">
                <a :href="urlKatalog">
                  {{ $translate("Bigtex5::Template.headerKatalog") }}
                </a>
              </li>
              <li class="ddown" v-if="calcTelTime">
                <a :href="urlPhone">
                  <i class="fa fa-phone"></i> {{ $translate("Bigtex5::Template.headerPhoneAssist") }}
                </a>
              </li>
            </template>
          </ul>
        </div>
        <template v-if="!isNavigationInitialized">
          <ul class="mainmenu w-100 p-0 m-0 menu-active">
            <li class="ddown" v-for="index in skeletonItemCount" :key="'skeleton-' + index">
              <span class="nav-placeholder m-3" :style="{width: getRandomWidth() + '%'}"></span>
            </li>
          </ul>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { MediaQueryHelper } from "../helper/MediaQueryHelper";
import { isNullOrUndefined, isDefined } from "../helper/utils";
import Vue from "vue";
import { mapState } from "vuex";

export default {

  props: {
    template: {
      default: "#vue-mobile-navigation",
      type: String
    },
    initialCategory: Object,
    breakpoints: {
      type: Array,
      default: () => ["xs", "sm", "md"]
    },
    blog: {
      type: Array,
      default: () => []
    },
    includeLanguage: Boolean
  },

  data()
  {
    return {
      dataContainer1: {
        parent: {},
        categories: []
      },
      dataContainer2: {
        parent: {},
        categories: []
      },
      useFirstContainer: false,
      isNavigationInitialized: false,
      selectedCategory: null,
      skeletonItemCount: 12
    };
  },

  computed:
      {
        selectedCat()
        {
          return this.selectedCategory;
        },
        urlNewsletter()
        {
          return App.ownURLS.urlNewsletter;
        },
        katalogEnabled()
        {
          return App.katalogEnabled === 'true' || App.katalogEnabled === true;
        },
        urlKatalog()
        {
          return App.ownURLS.urlKatalog;
        },
        urlKatalogImg()
        {
          return App.urlKatalogImg;
        },
        urlKatalogLink()
        {
          return App.katalogLink;
        },
        urlPhone()
        {
          return App.ownURLS.urlPhone;
        },
        urlContact()
        {
          return App.urls.contact;
        },
        breadcrumbs()
        {
          const breadcrumbs = [];
          let container = this.useFirstContainer ? this.dataContainer2 : this.dataContainer1;

          while (container && container.parent && Object.keys(container.parent).length)
          {
            breadcrumbs.unshift(
                {
                  name: container.parent.details[0].name,
                  parent: container.parent || null
                });

            container = container.parent;
          }

          return breadcrumbs;
        },
        ...mapState({
          navigationTree: state => state.navigation.tree,
          isMobileNavigationOpen: state => state.navigation.isMobileNavigationOpen
        })
      },

  watch:
      {
        isMobileNavigationOpen(isOpen)
        {
          if (isOpen && !this.isNavigationInitialized && this.navigationTree.length <= 0)
          {
            this.loadInitialTree();
          }
        }
      },

  created()
  {
    this.$store.commit("setCurrentCategory", this.initialCategory);
    this.skeletonItemCount = this.blog.length > 0 ? 8 : 12;
  },

  mounted()
  {
    this.setupBreakpointListener();
  },

  methods:
      {
        getRandomWidth()
        {
          return Math.floor(Math.random() * 30 + 50); // 50-80%
        },
        getRating()
        {
          return App.googleRating.replace('.',',');
        },
        calcTelTime()
        {
          const workingDaysLong    = [1,5];
          const workingDaysShort   = [2,3,4];

          const day       = new Date().getDay();
          const hour      = new Date().getHours();
          const minutes   = new Date().getMinutes();
          if( workingDaysLong.indexOf(day) > -1)
          {
            if(hour+minutes > 830 && hour+minutes < 1400 )
            {
              return true
            }
            else
            {
              return false;
            }
          }
          if( workingDaysShort.indexOf(day) > -1)
          {
            if(hour+minutes > 900 && hour+minutes < 1700 )
            {
              return true
            }
            else
            {
              return false;
            }
          }
          return false
        },

        // Registriert nur den Breakpoint-Listener, löst aber keinen sofortigen Load aus
        setupBreakpointListener()
        {
          const QueryHelper = new MediaQueryHelper();
          QueryHelper.addFunction(() => {
            // Breakpoint hat gewechselt zu Mobile – aber nur laden wenn Nav schon offen
            if (this.isMobileNavigationOpen && !this.isNavigationInitialized)
            {
              this.loadInitialTree();
            }
          }, this.breakpoints);
        },

        loadInitialTree()
        {
          if (this.navigationTree.length <= 0)
          {
            const categoryId = this.initialCategory && this.initialCategory.id ? this.initialCategory.id : null;

            this.$store.dispatch("loadPartialNavigationTree", categoryId)
                .then(response =>
                {
                  this.$store.commit("setNavigationTree", response);
                  this.initNavigation();
                });
          }
          else
          {
            // Tree bereits im Store (z.B. durch SSR oder vorherigen Load)
            this.initNavigation();
          }
        },

        initNavigation()
        {
          if (this.initialCategory && this.initialCategory.id)
          {
            if (this.initialCategory.linklist === "N")
            {
              this.$store.commit("setCurrentCategory", this.initialCategory);
            }
            else
            {
              this.$store.dispatch("setCurrentCategoryById", { categoryId: parseInt(this.initialCategory.id) });
              this.initialSlide(this.$store.state.navigation.currentCategory);
            }
          }

          this.dataContainer1.parent = null;
          this.dataContainer1.categories = this.navigationTree;
          this.isNavigationInitialized = true;
        },

        initialSlide(currentCategory)
        {
          if (currentCategory)
          {
            if (currentCategory.children)
            {
              this.slideTo(currentCategory);
            }
            else if (currentCategory.parent)
            {
              this.slideTo(currentCategory.parent);
            }
          }
        },

        slideTo(category, back)
        {
          const children = isDefined(category) ? category.children : this.navigationTree;
          const categoryId = isDefined(category) ? category.id : null;

          this.loadPartialTree(categoryId);
          this.selectedCategory = category;

          if (this.useFirstContainer)
          {
            this.dataContainer1.parent = category;
            this.dataContainer1.categories = children || [];

            $("#menu-2").trigger("menu-deactivated", { back: !!back });
            $("#menu-1").trigger("menu-activated", { back: !!back });
          }
          else
          {
            this.dataContainer2.parent = category;
            this.dataContainer2.categories = children || [];

            $("#menu-1").trigger("menu-deactivated", { back: !!back });
            $("#menu-2").trigger("menu-activated", { back: !!back });
          }

          this.useFirstContainer = !this.useFirstContainer;
        },

        loadPartialTree(categoryId)
        {
          // eslint-disable-next-line eqeqeq
          if (this.selectedCategory != categoryId ||
              (isDefined(this.selectedCategory) && this.selectedCategory.id !== categoryId))
          {
            this.$store.dispatch("loadPartialNavigationTree", categoryId)
                .then(response =>
                {
                  if ((isNullOrUndefined(this.selectedCategory) && isNullOrUndefined(categoryId)) ||
                      (isDefined(this.selectedCategory) && this.selectedCategory.id === categoryId))
                  {
                    this.$store.commit("setNavigationTree", response);
                    this.updateDataContainers(categoryId);
                  }
                });
          }
        },

        updateDataContainers(categoryId)
        {
          const containers = ["dataContainer1", "dataContainer2"];
          const category = this.getCategoryById(categoryId, this.navigationTree);

          for (const container of containers)
          {
            if (category)
            {
              this[container].parent = category;
              this[container].categories = category.children;
            }
            else
            {
              // root level
              this[container].parent = null;
              this[container].categories = this.navigationTree;
            }
          }
        },

        getCategoryById(categoryId, tree)
        {
          for (const cat of tree)
          {
            if (categoryId === cat.id)
            {
              return cat;
            }
            else if (cat.children)
            {
              const foundCat = this.getCategoryById(categoryId, cat.children);

              if (foundCat)
              {
                return foundCat;
              }
            }
          }

          return null;
        },

        closeNavigation()
        {
          this.$store.commit("setIsMobileNavigationOpen", false);
        },

        getCategoryUrl(url)
        {
          const trailingSlash = url[0] === "/" ? "" : "/";
          const prefix = this.includeLanguage ? `/${App.language}${trailingSlash}` : "";

          return prefix + url;
        }
      },

  directives:
      {
        menu: {
          bind(el)
          {
            // add "activated" classes when menu is activated
            $(el).on("menu-activated", (event, params) =>
            {
              $(event.target).addClass("menu-active");
              $(event.target).addClass(params.back ? "animate-in-from-left" : "animate-in-from-right");
            });
            // add "deactivated" classes when menu is deactivated
            $(el).on("menu-deactivated", (event, params) =>
            {
              $(event.target).removeClass("menu-active");
              $(event.target).addClass(params.back ? "animate-out-to-right" : "animate-out-to-left");
            });
            // this removes the animation class automatically after the animation has completed
            $(el).on("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", () =>
            {
              $(".mainmenu").removeClass((index, className) =>
              {
                return (className.match(/(^|\s)animate-\S+/g) || []).join(" ");
              });
            });
          }
        }
      }
}
</script>